/* unplugin-vue-components disabled */import script from "./ContentBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentBlock.vue?vue&type=script&lang=ts&setup=true"

import "./ContentBlock.vue?vue&type=style&index=0&id=70ea8fcb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ea8fcb"]])

export default __exports__